// assets/cart-custom.js
async function ccUpdateLine(lineKey, newQty) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: newQty })
  });
  if (!res.ok) throw new Error('Error al actualizar el carrito');
  window.location.reload();
}

document.addEventListener('click', (e) => {
  const removeBtn = e.target.closest('[data-remove]');
  if (removeBtn) { e.preventDefault(); ccUpdateLine(removeBtn.dataset.key, 0); return; }

  const minusBtn = e.target.closest('[data-minus]');
  if (minusBtn) {
    e.preventDefault();
    const wrap = minusBtn.closest('[data-line]');
    const input = wrap && wrap.querySelector('[data-qty-input]');
    const current = input ? parseInt(input.value, 10) || 1 : 1;
    const next = Math.max(0, current - 1);
    ccUpdateLine(minusBtn.dataset.key, next);
    return;
  }

  const plusBtn = e.target.closest('[data-plus]');
  if (plusBtn) {
    e.preventDefault();
    const wrap = plusBtn.closest('[data-line]');
    const input = wrap && wrap.querySelector('[data-qty-input]');
    const current = input ? parseInt(input.value, 10) || 0 : 0;
    const next = current + 1;
    ccUpdateLine(plusBtn.dataset.key, next);
  }
});
